import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Table } from "../../../components/Table";

import { Api } from "../../../services/api";
import { Office } from "../../../services/api/types/Offices";
import { Container } from "../Admin.styles";
import { getColumns, defaultDropDownFilters } from "./columnData";
import { TableTypes } from "../../../components/Table/Table.types";
import { handleAxiosError } from "../../../services/utils/handleAxiosError";
import { useAppSelector } from "../../../store/hooks";
import { UserPermissions } from "../../../enums";
import { filterUniqueKeys } from "../../../services/utils/filterUniqueKeys";

export const Offices = () => {
  const history = useHistory();
  const userPermissions = useAppSelector(state => state.auth.user.permissions);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Array<Office>>([]);
  const [dropDownFilters, setDropFilters] = useState<any>(null);

  useEffect(() => {
    fetchOffices();
  }, []);

  const fetchOffices = async () => {
    setIsLoading(true);

    try {
      const response = await Api.offices.get();
      const newDropDownFilters = filterUniqueKeys(
        response.data,
        defaultDropDownFilters,
        Object.keys(defaultDropDownFilters)
      );

      setDropFilters(newDropDownFilters);
      setTableData(response.data);
    } catch (error) {
      console.error("Offices fetch:", error);
      handleAxiosError(error);
    }

    setIsLoading(false);
  };

  let handleAddTeam;
  if (userPermissions.includes(UserPermissions.TeamAddTeam)) {
    handleAddTeam = () => {
      const currentLocation = history.location;
      currentLocation.pathname = `${currentLocation.pathname}/add`;
      history.push(currentLocation);
    };
  }

  return (
    <Container>
      <Table
        searchable
        title={TableTypes.Offices}
        tableType={TableTypes.Offices}
        isLoading={isLoading}
        defaultRows={20}
        columns={getColumns()}
        rowsPerPage={[10, 20, 35, 50]}
        dropDownFilters={dropDownFilters}
        data={tableData}
        handleAddButton={handleAddTeam}
      />
    </Container>
  );
};
